// Skeleton/constants.ts
export const SKELETON_BASE_COLOR = '#1a1a1a';
export const SKELETON_HIGHLIGHT_COLOR = '#2a2a2a';
